import { redirect } from 'react-router-dom'

/** Proforma links made before the slug was renamed to match the rest of the platform. */
export const LEGACY_PROFORMA_PATHNAME = '/documents/:orderId/proforma/:action?'

/**
 * redirectLegacyProforma - Route loader that sends an old `/proforma` document link to the
 * `/proforma-invoice` page, keeping the action (e.g. `export`). Customers may have bookmarked or
 * shared the old spelling.
 *
 * @param {{ params: { orderId: string, action?: string } }} args
 * @returns {Response} The redirect.
 */
export const redirectLegacyProforma = ({ params: { action, orderId } }) =>
    redirect(`/documents/${orderId}/proforma-invoice${action ? `/${action}` : ''}`)
